<template>
  <div
    :class="{ 'container mx-auto p-0': true }"
    data-testid="CTABanner"
  >
    <BackgroundImage
      v-if="data?.imageBackground"
      v-bind="data?.imageBackground"
      :class="{
        'cta-content-wrapper mx-auto my-10 max-w-320px rounded-xl bg-right px-5 py-18px md:max-w-612px md:px-10 md:py-30px lg:max-w-830px': true,
      }"
    >
      <div :class="contentAlignmentClasses">
        <h3
          :class="{
            'mb-1 text-13px font-medium leading-4 md:mb-4 md:max-w-1/2 md:text-2xl md:leading-7 lg:text-35px lg:leading-9': true,
          }"
        >
          {{ data?.title }}
        </h3>
        <p
          :class="{
            'mb-2px max-w-13/20 text-8px leading-3 md:mb-4 md:text-sm md:leading-4 lg:mb-7 lg:text-xl lg:leading-6': true,
          }"
        >
          {{ data?.subtitle }}
        </p>
        <div
          :class="{
            light: true,
          }"
        >
          <ButtonRow
            v-if="data?.cta"
            v-bind="data.cta"
            :class="{
              'text-8px': true,
            }"
          />
        </div>
      </div>
    </BackgroundImage>
  </div>
</template>

<script lang="ts" setup>
import type { CTABannerRefQueryResult } from '~/sanity/types';

interface PropsCTABannerRefQueryResult {
  data: CTABannerRefQueryResult;
}

const props = defineProps<PropsCTABannerRefQueryResult>();

const contentAlignmentClasses = computed(() => ({
  'cta-content-wrapper-text position-static flex flex-col': true,
  [props.data?.textAlignment ? alignmentClasses[props.data.textAlignment] : 'center']: true,
}));
const alignmentClasses: Record<string, string> = {
  left: 'text-left items-start',
  center: 'text-center items-center',
  right: 'text-right items-end',
};
</script>
<style>
@media (max-width: 787px) {
  .cta-content-wrapper .button-wrapper a {
    font-size: 8px !important;
    line-height: 14px !important;
  }
}
</style>
